export default {
  test: 'test',
};


// WEBPACK FOOTER //
// ./src/locales/ko-KR/test.ts